export { default as MultiSelector } from './MultiSelector';



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiSelector/index.ts